import classNames from 'classnames/bind';
import React, { forwardRef, useRef } from 'react';

import styles from './TypeNumber.module.scss';

const cx = classNames.bind(styles);

const TypeNumber = forwardRef(({ className, min, max, onBlur, ...props }, ref) => {
  const prevValue = useRef(null);

  const handleKeyDown = (e) => {
    if (e.nativeEvent.isComposing) return;

    if (e.code === 'Enter') {
      e.target.blur();
    }

    if (props.onKeyDown) {
      props.onKeyDown(e);
    }
  };

  const handleFocus = (e) => {
    // 포커스 시 현재 값을 저장 (이전 유효값)
    prevValue.current = e.target.value;
  };

  const handleBlur = (e) => {
    const value = Number(e.target.value);

    // min/max 검증 - 실패하면 이전 값으로 복원
    if ((min !== undefined && value < min) || (max !== undefined && value > max)) {
      e.target.value = prevValue.current;
      return;
    }

    onBlur?.(e);
  };

  return (
    <input
      ref={ref}
      type="number"
      {...props}
      onKeyDown={handleKeyDown}
      onFocus={handleFocus}
      onBlur={handleBlur}
      className={cx(['container', className])}
    />
  );
});

export default TypeNumber;
